import { render, staticRenderFns } from "./UserIndexTable.vue?vue&type=template&id=2a916bf6&scoped=true&"
import script from "./UserIndexTable.vue?vue&type=script&lang=js&"
export * from "./UserIndexTable.vue?vue&type=script&lang=js&"
import style0 from "./UserIndexTable.vue?vue&type=style&index=0&id=2a916bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a916bf6",
  null
  
)

export default component.exports